var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isMask
    ? _c("div", { staticClass: "w-header-mask" }, [
        _c("div", { staticClass: "w-header-mask-box" }, [
          _c("img", {
            staticClass: "w-header-mask-box-close",
            attrs: { src: _vm.closeImg },
            on: { click: _vm.closeMask }
          }),
          _vm._v(" "),
          _c("p", { staticClass: "w-header-mask-box-title" }, [
            _vm._v("选择发布的活动类型")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-header-mask-box-modal" }, [
            _c(
              "div",
              {
                staticClass: "w-header-mask-box-modal-light",
                on: { click: _vm.lightFun }
              },
              [
                _c("img", {
                  staticClass: "w-header-mask-box-modal-light-img",
                  attrs: { src: _vm.lightImg }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "w-header-mask-box-modal-light-title" },
                  [_vm._v("报名")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "w-header-mask-box-modal-light-content" },
                  [
                    _vm._v(
                      "聚会、沙龙、排队、培训、会议、粉丝赠票、签到二维码、可审核、可付费、邀请函"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "w-header-mask-box-modal-light-mask" })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "w-header-mask-box-modal-light",
                on: { click: _vm.eventeFun }
              },
              [
                _c("img", {
                  staticClass: "w-header-mask-box-modal-light-img",
                  attrs: { src: _vm.eventImg }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "w-header-mask-box-modal-light-title" },
                  [_vm._v("票务")]
                ),
                _vm._v(" "),
                _c(
                  "p",
                  { staticClass: "w-header-mask-box-modal-light-content" },
                  [
                    _vm._v(
                      "剧场、音乐节、巡演、赛事、会议、展览、游园、多票种、多场次、选座、秒杀抢票、多种核销、代金券、年卡、外币支付"
                    )
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "w-header-mask-box-modal-light-mask" })
              ]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8899f0d2", { render: render, staticRenderFns: staticRenderFns })
  }
}